export default (data, fields) => ({
    ...Object.assign(...Object.values(fields).map(fieldName => ({
        [fieldName]: data[fieldName],
    })))
});
